// Nađi roditeljski div
const parent = document.querySelector('.wpforms-field-container');

// Nađi prva dva diva
const div1 = document.querySelector('#wpforms-38-field_1-container');
const div2 = document.querySelector('#wpforms-38-field_2-container');

// Napravi novi wrapper div
const wrapper = document.createElement('div');
wrapper.classList.add('contact-banner__inputs-wrapper');

// Ubaci box1 i box2 u wrapper
wrapper.appendChild(div1); 
wrapper.appendChild(div2);

// Ubaci wrapper na početak parenta, ispred box3
parent.insertBefore(wrapper, parent.firstChild.nextSibling);
